import {Component, input, OnInit} from '@angular/core';

@Component({
  selector: 'app-new-item-skeleton',
  templateUrl: './new-item-skeleton.component.html',
  styleUrls: ['./new-item-skeleton.component.scss']
})
export class NewItemSkeletonComponent  implements OnInit {

  type = input<'vertical' | 'horizontal'>();
  fullWidth = input<boolean>();

  constructor() { }

  ngOnInit() {}


}
